export const  convertTimezoneDayMonth=(currentShiftTime, targetTimezoneString)=> {
    if (currentShiftTime !== null && currentShiftTime !== "" && currentShiftTime !== undefined && targetTimezoneString) {
      const utcMatch = targetTimezoneString.match(/UTC\s?([-+]\d+):(\d+)/);
      if (!utcMatch) {
        throw new Error("Invalid timezone string format");
      }
      const targetHoursOffset = parseInt(utcMatch[1], 10);
      const targetMinutesOffset = parseInt(utcMatch[2], 10);
      const targetTotalOffsetMinutes =
        targetHoursOffset * 60 + targetMinutesOffset;
      const currentOffsetMinutes = 5 * 60 + 30;
      const currentDate = new Date(currentShiftTime);
      const shiftUTC = currentDate.getTime() - currentOffsetMinutes * 60000;
      const targetShiftTime = new Date(
        shiftUTC + targetTotalOffsetMinutes * 60000
      );

      const day = targetShiftTime.getDate();
      const month = targetShiftTime.toLocaleString("default", {
        month: "short",
      });
      const year = targetShiftTime.getFullYear();
      const hours = targetShiftTime.getHours();
      const minutes = targetShiftTime.getMinutes();
      const formattedHours = hours % 12 || 12;
      const ampm = hours >= 12 ? "PM" : "AM";
      const formattedMinutes = String(minutes).padStart(2, "0");
      const formattedTime = `${formattedHours}:${formattedMinutes} ${ampm}`;
      const formattedDate = `${day} ${month} '${String(year).slice(2)}`;
      const datedone = `${formattedTime} ,${formattedDate}`;
      return datedone;
    }
  }